import Nullstack from 'nullstack';
export default function IconSignRight({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-sign-right",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M8 21h4"
  }), "   ", Nullstack.element("path", {
    d: "M10 21v-10"
  }), "   ", Nullstack.element("path", {
    d: "M10 6v-3"
  }), "   ", Nullstack.element("path", {
    d: "M6 6h10l2 2.5l-2 2.5h-10z"
  }), " ");
}